import axios from '../javascript/custom-axios'
const V1 = '/v1'
const V2 = '/v2'
const RESOURCE_NAME = '/users'

export default {
    getPosts(key, Page, PageSize, Search = '', GroupIds = '', Type='individual') {
        //Filtreleme servisi arka tarafta ayrı yazılmış
        //Bu nedenle burada filtre filedı kontrol ediliyor ve ilgili servis tetikleniyor.
        let routeName = GroupIds ? 'postsFilter' : 'posts'
        return axios.get(`${V1}${RESOURCE_NAME}/${routeName}?Key=${key}&Page=${Page}&PageSize=${PageSize}&Search=${Search}&GroupIds=${GroupIds}&Type=${Type}`)
    },

    getUsers(search) {
        return axios.get(`${V1}${RESOURCE_NAME}/?isLight=false&search=${search}`)
    },

    postEndorsement(body) {
        return axios.post(
            `${V2}${RESOURCE_NAME}/UserEndorsements/create`, body,
        );
    },

    getUserInfo(id) {
        return axios.get(`${V1}${RESOURCE_NAME}/${id}`)
    },

    changeProfilePhoto(formData){
        return axios.post(`${V1}${RESOURCE_NAME}/update_avatar`, formData, {
            headers: {'Content-Type': 'multipart/form-data'},
          })
    },

    updateUserInfo(id, body){
        return axios.put(`${V1}${RESOURCE_NAME}/${id}`, body)
    },

    getProfileLikedPosts(page = 1, pagesize = 100){
        return axios.get(`${V1}${RESOURCE_NAME}/userLiked?page=${page}&pageSize=${pagesize}`)
    },

}
